// @flow
export default (radio1: Object, radio2: Object) => radio1.title === radio2.title;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Radio/util/compareRadioObject.js